<div class="bg-blue persona-container">
    <apc-navbar-big [items]=navigation></apc-navbar-big>
    <div class="content">
        <app-datatable [service]="customersService.getCustomers"
            [defaultColumns]="defaultColumns" [columnsToExclude]="columnsToExclude" [section]="'customers'">
        </app-datatable>
    </div>
</div>